<ng-container
    *ngTemplateOutlet="cellTemplate; context: cellContext"
></ng-container>
<div *ngIf="isColHeader" 
    class="mibi-shadow-chrome mibi-shadow-chrome--bottom"
></div>
<div *ngIf="isRowHeader"
    class="mibi-shadow-chrome mibi-shadow-chrome--right"
></div>
<div *ngIf="isHeader"
    class="mibi-overlay"
    [ngClass]="{
        'mibi-selection-hint': !isHoverHinted && isSelectionHinted,
        'mibi-hover-hint': isHoverHinted && !isSelectionHinted,
        'mibi-selection-hover-hint': isHoverHinted && isSelectionHinted
    }"
></div>
<div class="mibi-overlay"
    [ngClass]="{
        'mibi-selection--hover': isHovered,
        'mibi-selection--selected': !hasCursor && isSelected,
        'mibi-selection--selected-hover': !hasCursor && isSelected && isHovered,
        'mibi-selection-anchor': !hasCursor && hasSelectionAnchor,
        'mibi-cursor': hasCursor
    }"
></div>
